<template>
  <div class="d-flex align-items-center w-full">
    <a-select
      :disabled="loading"
      :value="value"
      showArrow
      :mode="isViewscreen ? 'default' : 'multiple'"
      size="large"
      @change="onChange"
      option-filter-prop="children"
      show-search
      filter-option
    >
     <template #placeholder>
        <span style="color: #a1a1c2">Choose segments</span>
      </template>
      <a-select-opt-group
        v-for="(segments, project) in groupedSegments"
        :key="project"
        :label="project"
      >
        <a-select-option
          v-for="segment in segments"
          :key="segment.id"
          :value="segment.id"
        >
          {{ segment.name }}
        </a-select-option>
      </a-select-opt-group>
    </a-select>
  </div>
</template>

<script>
export default {
  name: 'SegmentSelect',

  props: {
    value: {
      type: Array,
      default: () => [],
    },
    segments: {
      type: Array,
      default: () => [],
    },

    loading: {
      type: Boolean,
      default: false,
    },
    isViewscreen: {
      type: Boolean,
      default: false,
    },
  },

  computed: {
    groupedSegments() {
      if (!Array.isArray(this.segments)) return {}

      return this.segments.reduce((acc, segment) => {
        const projects = segment?.projects
        if (!Array.isArray(projects) || !projects.length) return acc

        const groupLabel = [...new Set(projects)]
          .sort()
          .join(' & ')

        if (!acc[groupLabel]) acc[groupLabel] = []

        acc[groupLabel].push(segment)

        return acc
      }, {})
    },
  },

  methods: {
    onChange(val) {
      this.$emit('input', val)
      this.$emit('change', val)
    },
  },
}
</script>
